export type ProfileFieldKind = 'string' | 'integer' | 'number' | 'boolean' | 'date' | 'datetime' | 'list';

type ProfileFieldOption = {
  id: string;
  value: string;
};

type ProfileFieldCustomField = {
  id: string;
  kind: ProfileFieldKind;
  name: string;
  display: string;
  system_reserved: boolean;
  options: ProfileFieldOption[];
};

export type ProfileFieldValue = string | number | boolean | string[] | null;

export enum ProfileFieldValueStatus {
  Valid = 'valid',
  Unanswered = 'unanswered',
  Invalid = 'invalid',
}

export type BuiltInFieldKey = 'headline' | 'location' | 'avatar';

export type CommunityProfileField = {
  id: string;
  system_key?: BuiltInFieldKey | null;
  custom_field_id: string | null;
  display: string;
  asked_as: string | null;
  visibility: 'public' | 'private' | 'hidden';
  required: boolean;
  onboarding_position: number | null;
  directory_position: number | null;
  custom_field: ProfileFieldCustomField | null;
  value: ProfileFieldValue;
  value_status: ProfileFieldValueStatus;
};

export type CommunityProfileFieldsPayload = {
  profile_setup_required: boolean;
  profile_fields: CommunityProfileField[];
};

export type ProfileFieldAnswer = {
  id: string;
  value: ProfileFieldValue;
};

export type ProfileFieldErrors = Record<string, string[]>;
